import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Image } from '@chakra-ui/react';

import easyImg from 'assets/brand/easy@2x.png';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import { StepProps } from 'components/Stepper/types';
import * as ContentLayout from 'layouts/ContentLayout';

import locales from './locales';
import * as S from './styles';

const FAQ_LINK = 'https://help.shine.fr/fr/articles/2180615';

const StepMandateNothingToDo: FC<StepProps> = () => (
  <ContentLayout.Root>
    <ContentLayout.Body>
      <S.Container>
        <Image alt="" boxSize={180} marginBottom="space-24" src={easyImg} />

        <Heading marginBottom="space-16" marginTop="space-24" size="lg">
          {locales.title}
        </Heading>

        <Text marginBottom="space-32">{locales.explanation}</Text>

        <Button
          as="a"
          href={FAQ_LINK}
          icon="link"
          marginBottom="space-40"
          target="_blank"
          variant="inline-secondary"
        >
          {locales.link}
        </Button>

        <S.CtaButtonContainer>
          <Button as={Link} to="/payments" width="100%">
            {locales.cta}
          </Button>
        </S.CtaButtonContainer>
      </S.Container>
    </ContentLayout.Body>
  </ContentLayout.Root>
);

export default StepMandateNothingToDo;
